import {Breakpoints, styled} from '@volkswagen-onehub/components-core';
import React, {useContext} from 'react';
import {Actions} from '../Actions';
import {
  ResultsView,
  ResultsViewContext,
} from '../../../utils/results-view-context';
import { VehicleContext } from '../../../utils/vehicle-context';

interface CardActionsContainerInterface {
  view: ResultsView;
}

const CardActionsContainer = styled.div<CardActionsContainerInterface>`
  grid-area: actions;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0;

  @media (min-width: ${Breakpoints.b960}px) {
    justify-content: ${(props) => props.view == ResultsView.LIST ? 'flex-start' : 'center'};
    ${(props) => props.view == ResultsView.GRID && `padding: ${props.theme.size.dynamic0020};`}
  }
`;

const CardActions : React.FC = () => {
  const view = useContext(ResultsViewContext).value;
  const vehicle = useContext(VehicleContext);
  const sold = vehicle?.deleted;

  return !sold ? (
    <CardActionsContainer view={view}>
      <Actions />
    </CardActionsContainer>
  ) : null;
};

export default CardActions;
